import { Link, useNavigate, useParams } from 'react-router-dom'
import useModalTrigger from 'magik-react-hooks/useModalTrigger'
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import { CategoriaOpera } from '../../types'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import Page from '../../components/Page'
import Header from '../../components/Header'
import CategoriaOperaForm from '../../components/CategoriaOperaForm'
import { useCategoriaOpera, useDeleteCategoriaOpera, useUpdateCategoriaOpera } from '../../hooks/categorie-opere'

export default function CategorieOpereEdit() {
  const { id } = useParams()
  const { data: categoria } = useCategoriaOpera(+id!)
  const deleteCategoria = useDeleteCategoriaOpera()
  const updateCategoria = useUpdateCategoriaOpera()
  const [modalRm, modalRmActions] = useModalTrigger<CategoriaOpera>()
  const navigate = useNavigate()

  return (
    <Page>
      <Header margins>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/categorie-opere">Categorie opere</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              {categoria!.nome}
            </li>
          </ol>
        </nav>
        <div className="d-flex align-items-center">
          <button
            className="btn btn-danger"
            onClick={() => modalRmActions.open(categoria)}
          >
            <i className="bi bi-trash3-fill"></i> Elimina
          </button>
        </div>
      </Header>
      <div className="py-3 overflow-y-auto flex-1">
        <CategoriaOperaForm
          categoria={categoria}
          save={(gruppo) =>
            updateCategoria.mutateAsync(gruppo).then(() =>
              toast.success('Categoria opera salvata con successo', {
                position: toast.POSITION.TOP_RIGHT,
                theme: 'colored',
              })
            )
          }
        />
      </div>
      <Modal centered isOpen={modalRm.isOpen} toggle={modalRmActions.toggle}>
        <ModalHeader toggle={modalRmActions.toggle}>Elimina</ModalHeader>
        <ModalBody>
          {modalRm.value && (
            <div className="pt-3 pb-3">
              Sei sicuro di voler eliminare la categoria opera {modalRm.value.nome} ?
            </div>
          )}
        </ModalBody>
        <ModalFooter className="d-flex justify-content-between">
          <button
            onClick={modalRmActions.toggle}
            className="btn btn-outline-primary"
          >
            Annulla
          </button>
          <button
            className="btn btn-danger"
            disabled={deleteCategoria.isLoading}
            onClick={async () => {
              await deleteCategoria.mutateAsync(modalRm.value!.id)
              navigate('/categorie-opere')
            }}
          >
            <i className="bi bi-trash3-fill"></i> Elimina
          </button>
        </ModalFooter>
      </Modal>
    </Page>
  )
}
